import { render } from "./newsBackNo.vue?vue&type=template&id=6e75b087&scoped=true&ts=true"
import script from "./newsBackNo.vue?vue&type=script&setup=true&lang=ts"
export * from "./newsBackNo.vue?vue&type=script&setup=true&lang=ts"

import "./newsBackNo.vue?vue&type=style&index=0&id=6e75b087&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e75b087"],['__file',"src/components/scan/newsinfo/newsBackNo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e75b087"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e75b087', __exports__)) {
    console.log('reload')
    api.reload('6e75b087', __exports__)
  }
  
  module.hot.accept("./newsBackNo.vue?vue&type=template&id=6e75b087&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6e75b087', render)
  })

}


export default __exports__